export default function getFontFamily(fontFamilyType, fontWeight, coreTheme) {
  var ffType = fontFamilyType === 'secondary' ? 'sec' : 'pri';
  return coreTheme["ff_".concat(ffType, "_").concat(fontWeight)];
}